<h1 mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    Create a product
</h1>
<mat-dialog-content>
    <div class="container-fluid p-2" [formGroup]="paymentPlanForm">
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter the name of your plan</mat-label>
                <mat-error>You need to enter a value</mat-error>
                <input matInput placeholder="Ex. Bronze plan" formControlName="productName" required>
                <mat-hint>Enter the name of your plan</mat-hint>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter a description for your playment plan</mat-label>
                <mat-error>You need to enter a value</mat-error>
                <input matInput placeholder="Perfect for small and medium businesses"
                    formControlName="productDescription" required>
                <mat-hint>Enter a description for your playment plan</mat-hint>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter your monthly pricing</mat-label>
                <mat-error>You need to enter a value</mat-error>
                <input matInput placeholder="50$" type="number" formControlName="monthlyPricing" required>
                <mat-hint>This is how much your customers will be charged per month</mat-hint>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter your overage limit.</mat-label>
                <mat-error>You need to enter a value</mat-error>
                <input matInput placeholder="200 minutes" formControlName="overageLimit" required>
                <mat-hint>This is the amount of minutes included per month</mat-hint>
            </mat-form-field>
        </div>  
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter your overage charge.</mat-label>
                <mat-error>You need to enter a value</mat-error>
                <input matInput placeholder="0.10$ current price per minute" type="number" formControlName="overageCharge" required>
                <mat-hint>This is the price per minute charged if the client exceeds their limit.</mat-hint>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around" *ngIf="!isLoading">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn">Close</button>
    <button mat-raised-button class="w-25" color="primary" [disabled]="!paymentPlanForm.valid"
        (click)="onProductCreated()">Save</button>
</mat-dialog-actions>
<mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>